import { Dispatch, ThunkAction } from 'app/types/actions';
import { fetchHandler } from 'app/util/fetchHandler';
import { Util } from 'app/util/util';
import { REST_WEBHOOKS } from 'app/rest/constants';
import { getRestHeadersPost } from 'app/rest/helpers/getRestHeadersHelper';
import { TBoardId } from '../../../../types/types';

export const postRest = (
    boardId: TBoardId,
    webhooks: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        return fetchHandler<string>(
            Util.getApiUrl(REST_WEBHOOKS + boardId), {
                ...getRestHeadersPost(),
                body: JSON.stringify({ webhookUrl: webhooks }),
            }
        );
    };
    return action;
};
